import { render } from "./TheDemandActionButton3.vue?vue&type=template&id=29ed7d51"
import script from "./TheDemandActionButton3.vue?vue&type=script&lang=js"
export * from "./TheDemandActionButton3.vue?vue&type=script&lang=js"
script.render = render

export default script